import React from 'react';
import './LogoMinymol.css';

const LogoMinymol = () => {
  return (
    <div className="logo-container-minymol" onClick={() => window.location.href = '/'}>
      <span className="logo-minymol">
        m<span className="i">i<span className="dot">•</span></span>n
        <span className="y">y</span>mol
      </span>
    </div>
  );
};

export default LogoMinymol;
